import { ComponentType, Suspense } from "react"
import { useModals } from "context/modals/hooks/useModals"
import { ALL_MODALS, MODAL_CONFIG } from "context/modals/constructor"

export const ModalsRoot = () => {
  const { modals } = useModals()

  return (
    <>
      {ALL_MODALS.map((modalType) => {
        const isOpen = modals[modalType]
        if (!isOpen) return null

        const modalConfig = MODAL_CONFIG[modalType]
        if (!modalConfig || !("component" in modalConfig)) {
          return null
        }

        if ("inRouter" in modalConfig && modalConfig.inRouter === false) {
          const ModalComponent = modalConfig.component as ComponentType
          return (
            <Suspense key={String(modalType)}>
              <ModalComponent />
            </Suspense>
          )
        }

        return null
      })}
    </>
  )
}
